module.exports = __webpack_public_path__ + "ico-crypto-axs.svg?20c5555bdd39ab70c5900a84c9335095";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/ico-crypto-axs.svg
// module id = 1157
// module chunks = 2